$(function() {
  // 地址管理相关定义
  var form = null,
      laypage = null,
      pagenav = null,
      provinces_html = '',
      citys = '',
      citys_html = '',
      contries = '',
      contries_html = '',
      now_address_id = ''
  var areas = BASE.getAreafromSession()
  if (!areas) {
    BASE.getArea(function(res) {
      if (!res[0] && res[1].data[0].children) {
        BASE.setAreatoSession(res[1].data[0].children)    
        areas = res[1].data[0].children
        Area.getProvince()
      } else {
        layer.msg(res)
      }
    })
  }  

  // 订单列表搜索条件
  var orderparams = {
    page_size: 10,
    page: 1,
    orderStatus: 0
  }

  // 获取省市区&省市选择联动
  var Area = {
    getProvince: function() {
      provinces_html = Area.generateOptions(areas, '省')
    },
    getCity: function(arr) {      
      citys_html = Area.generateOptions(arr, '市')
    },    
    getCountry: function(arr) {      
      contries_html = Area.generateOptions(arr, '区')
    },     
    generateOptions: function(arr, type) {
      return arr.reduce(function (a, b, i) {
        return a + '<option data-index="'+ i + '" value="'+ b.id +'">'+ b.perm_name + '</option>'
      }, '<option value="">请选择'+ type +'</option>')      
    },
    handleProvinceSelect: function(data) {
      var index = $(data.elem).find("option:selected").data('index')
      if (!isNaN(index)) {
        $('#country_id').html('')
        form.val('addressform', { 'country_id': '' })
        citys = areas[index].children
        Area.getCity(citys)
        $('#city_id').html(citys_html)
        form.render('select', 'addressform')                   
      }      
    },
    handleCitySelect: function(data) {
      var index = $(data.elem).find("option:selected").data('index')
      if (!isNaN(index)) {
        contries = citys[index].children
        Area.getCountry (contries)
        $('#country_id').html(contries_html)
        form.render('select', 'addressform')                   
      }      
    }
  }

  // layui组件加载完成后执行
	layui.use(['layer', 'laypage', 'form'], function(){
    form = layui.form  
    layer = layui.layer
    laypage = layui.laypage
    let token = CookieUtil.get('hwUserToken')          
    if (!token) {
      layer.msg('未检测到登录账号，即将返回首页')
      // setTimeout(function() {
      //   location.href = '/'
      // }, 3000)
      return
    }          
    // 添加地址提交
		form.on('submit(addressform)',function(data) {
      var condition = $.extend({}, data.field)
      condition.default_flag = condition.default_flag === 'on'
      if (now_address_id) {
        condition.id = now_address_id
        MALL.editAddress(condition, function(res) {
          if (!res[0]) {
            layer.closeAll()
            layer.msg('地址编辑成功')
            getAddlist()          
          }          
        })
      } else {
        MALL.addAddress(condition, function(res) {
          if (!res[0]) {
            layer.closeAll()
            layer.msg('成功添加新地址')
            getAddlist()          
          }
        })
      }      
    })      
    // 修改密码提交
    form.verify({
      samenewpsd: function(value, item) {
        if (value != $('#npwd').val()) {
          return '两次输入的密码不一致'
        }
      }
    })
    form.on('submit(pwdform)', function(data) {
      var condition = {
        opwd: data.field.opwd,
        npwd: data.field.npwd
      }
      USER.editPwd(condition, function(res) {
        if (!res[0]) {
          var index = layer.open({
            type: 1,
            area: '400px',
            shade: 0.8,
            id: 'psddialog',
            move: false,
            content: $('.psd-dialog'), 
            success: function(res) {
              $(res).on('click', '.cancel', function() {
                psdReset()
                layer.close(index)
              })
              $(res).on('click', '.relogin', function() {
                CookieUtil.unset('hwUserToken')
                CookieUtil.unset('hwUserData')
                location.href = '/'             
              })              
            }           
          })
        }
      })
    })

    // 订单列表
    let olistdom = document.getElementById('orderlist')
    if (olistdom) {   
      getOrderlist()
      MALL.getOrderSummary(function(res) {
        if (!res[0]) {
          let data = res[1].data
          $.each(data, function(key, value) {
            $('#' + key).html(value)
          })
        }
      })  
    }

    // 地址列表
    let listdom = document.getElementById('addresslist')
    if (listdom) {
      getAddlist()
      if (areas) {
        Area.getProvince()
      }      
    }      

    // 创建订单
    let ocreatedom = document.getElementById('ordercreatebox')
    if (ocreatedom) {
      let params = [{
        sku_id: 37, sku_quantity: 1
      }]
      
      MALL.purchaseDirect(params, function(res) {
        if (!res[0]) {
          let data = res[1].data
          $(ocreatedom).html('')
          let order = new orderCreateList(data)
          $(ocreatedom).append(order.init())
        }
      })
    }
  })
  
  // 地址框item 
  class AddressItem { 
    constructor(data) {
      $.extend(this, data)   
    }
    init() {
      let self = this
      var html = 
      '<li class="mall-address-list-item '+ (this.default_flag ? 'default current' : '') + '" data-item_type="normal" data-addid="'+ this.id +'" >' +
      '  <div class="person">'+ this.receiver_name +'</div>' +
      '  <div class="phone">'+ blurryPhone(this.receiver_mobile) +'</div>' +
      '  <div class="address">' +
      '    <p>'+ this.address_name +'</p>' +
      '    <p>'+ this.address_detail +'</p>' +
      '  </div>' +
      '  <div class="operate">' +
      '    <a class="setdefault" href="javascript:;"><img src="/@@/images/mall/address-default.svg">'+ (this.default_flag ? '取消默认' : '设为默认') +'</a>' +
      '    <a class="edit" href="javascript:;"><img src="/@@/images/mall/address-edit.svg">修改</a>' +
      '    <a class="remove" href="javascript:;"><img src="/@@/images/mall/address-delete.svg">删除</a>' +
      '  </div>' +
      '  <div class="default-tag">' +
      '    &nbsp;默认地址' +
      '  </div> ' +
      '</li>'  
      var dom = $(html)
      dom.on('click', 'a', function(e) {
        var type = e.target.className
        switch (type) {
          case 'setdefault':
            self.setDefault()
            break;
          case 'edit':
            self.edit()
            break;
          default:
            self.remove(dom)
        }
      })  
      return dom       
    }
    remove(dom) {
      var self = this
      var index = layer.open({
        type: 1,
        title: '删除地址' ,
        area: '380px;',
        shade: 0.8,
        id: 'addressDelete',
        move: false,
        content: $('.delete-dialog'),
        success: function(ele) {
          $(ele).on('click', 'a', function(e) {
            let type = $(this).data('method')
            if (type === 'cancel') {
              layer.close(index)
            } else {              
              MALL.deleteAddress(self.id, function(res) {
                if (!res[0]) {
                  layer.msg('成功删除地址')
                  layer.close(index)
                  dom.off()
                  getAddlist()
                }
              })
            }
          })
        }
      })
    }
    edit() {
      var self = this      
      var index = layer.open({
        type: 1,
        title: '编辑收货地址' ,
        area: '460px',
        shade: 0.8,
        id: 'addressEdit',
        move: false,
        end: addReset,
        content: $('.edit-dialog'), 
        success: function(res) {
          now_address_id = self.id
          $('#province_id').html(provinces_html)     
          citys = areas.find(item => {
            return item.id == self.province_id
          }).children
          Area.getCity(citys)
          $('#city_id').html(citys_html)
          contries = citys.find(item => {
            return item.id == self.city_id
          }).children
          Area.getCountry(contries)
          $('#country_id').html(contries_html)
          form.render('select', 'addressform') 
          form.val("addressform", {
            address_detail: self.address_detail,
            city_id: self.city_id,
            country_id: self.country_id,
            default_flag: self.default_flag,
            province_id: self.province_id,
            receiver_mobile: self.receiver_mobile,
            receiver_name: self.receiver_name
          })      
          form.on('select(province_id)', function(data) {
            Area.handleProvinceSelect(data)
          })  
          form.on('select(city_id)', function(data) {
            Area.handleCitySelect(data)
          })              
          $(res).on('click', '.cancel', function() {
            layer.close(index)
          })              
        }       
      })
    }
    setDefault() {
      var self = this
      var condition = {
        id: self.id,
        default_flag: !self.default_flag        
      }
      MALL.setDefault(condition, function(res) {
        if (!res[0]) {
          layer.msg('设置成功')
          getAddlist()
        } else {
          layer.msg(res[0].responseText)
        }        
      })
    }
  }

  // 订单列表item
  class OrderlistItem {
    constructor(data) {
      $.extend(this, data)
      this.status_txt = {
        10: '待支付',
        20: '已支付',
        150: '已取消'
      }
    }
    init() {
      let self = this
      // 目前只有一个地磅商品
      let good = this.order_skus[0]
      let done = this.order_status === 20
      let cancel = this.order_status === 150
      let html = `
      <li class="detail-item">
        <div class="detail-item-head">
          <span class="detail-item-head-num">订单号：${this.order_no}</span>
          <span class="detail-item-head-date">
            ${new Date(this.created_time).format('yyyy/MM/dd  hh:mm:ss')}
          </span>
        </div>
        <div class="detail-item-main detail-box">
          <div class="detail-item-main-skuinfo">
            <img src="${good.product_image}" alt="">
            <div>
              <p class="context">${good.title}</p>
              <p class="price">${formatCurrency(good.sku_price / 100)} × ${good.sku_quantity}</p>
              <p class="standard">地磅型号：官方标配</p>
            </div>
          </div>
          <div class="detail-item-main-price">${formatCurrency(good.sku_vendor_price / 100)}</div>
          <div class="detail-item-main-status ${cancel ? 'cancel' : done ? 'done' : ''} ">
            ${this.status_txt[this.order_status]}
          </div>
          <div class="detail-item-main-operate ${cancel ? 'cancel' : done ? 'done' : ''}">
            <a href="javascript:;" data-operate="pay" class="button pay">立即支付</a>
            <a href="javascript:;" data-operate="cancel" class="button cancel">取消订单</a>
            <a href="/mall/ordercreate.html" data-operate="rebuy" class="button rebuy">再次购买</a>
          </div>
        </div>
      </li>`
      let dom = $(html)
      dom.on('click', '.button', function(e) {
        let type = $(this).data('operate')
        switch (type) {
          case 'pay':
            self.payOrder()
            break;
          case 'cancel':
            self.cancelOrder()
            break;
          default:
            self.payAgain(dom)
        }
      })
      return dom
    }
    payOrder() {
      MALL.generatePay(this.order_id, function(res) {
        if (!res[0]) {
          if (res[1].code === 0) {
            let payform = $(res[1].data)
            $(payform[0]).attr('target', '_blank')
            $('html body').append(payform)
            layer.open({
              title: '提示',
              closeBtn: 0,
              content: '订单支付中',
              btn: ['支付完成', '再看看'],
              yes: function() {
                location.href='/mall/orderlist.html'       
              },
              btn2: function() {
                location.href = '/mall/loadometer.html'
              }   
            })             
          }
        }
      })
    }
    cancelOrder() {
      let self = this
      let index = layer.open({
        title: '提示',
        content: '确认删除该订单？',
        btn: ['确定', '取消'],
        yes: function() {
          layer.close(index)
          MALL.cancelOrder(self.order_id, function(res) {
            if (!res[0]) {              
              layer.msg('成功取消订单')
              getOrderlist()
            }
          })          
        }
      })
    }
    payAgain() {
      location.href='/mall/ordercreate.html'
    }
  }

  // 创建订单item
  class orderCreateList {
    constructor(data) {
      this.list = data.list
      this.good = this.list[0].items[0]
      this.quantity_num = data.quantity_num
      this.vendor_price = data.vendor_price
    }
    init() {
      let self = this
      let html = `
      <div class="mall-deliverylist">
        <div class="mall-deliverylist-item">
          <div class="mall-deliverylist-item-skuinfo">
            <a href="${this.good.product_image}" target="_blank">
              <img src="${this.good.product_image}" alt="">
            </a>            
            <div>
              <div class="standard">官方标配</div>
              <div class="title">${this.good.title}</div>                
            </div>                
          </div>
          <div class="mall-deliverylist-item-quantity">
            <div class="count">
              <span data-btntype="minus" class="count-btn">-</span>
              <span class="count-value quantity">${this.quantity_num}</span>
              <span data-btntype="plus" class="count-btn">+</span>
            </div>
          </div>
          <div class="mall-deliverylist-item-calculate">
            ${formatCurrency(this.good.sku_price / 100)} X <span class="quantity">${this.quantity_num}</span></div>
          <div class="mall-deliverylist-item-result price">${formatCurrency(this.vendor_price / 100)}</div>
        </div>
      </div>
      <h3 style="padding-left:20px;line-height: 40px;">
        配送方式 <span style="margin-left:30px;color:#666;font-size: 12px">送货上门</span>
      </h3>
      <div class="mall-deliverylist-settlement">
        <ul class="mall-deliverylist-settlement-detail">
          <li class="mall-deliverylist-settlement-detail-item">
            <div>商品件数：</div>
            <div>
              <span id="sku_quantity" class="quantity">${this.quantity_num}</span>件</div>
          </li>
          <li class="mall-deliverylist-settlement-detail-item">
            <div>商品总价：</div>
            <div class="price">${formatCurrency(this.vendor_price / 100)}</div>
          </li>
          <li class="mall-deliverylist-settlement-detail-item">
            <div>运费：</div>
            <div>￥0.00</div>
          </li>  
          <li class="mall-deliverylist-settlement-detail-item">
            <div>应付总额：</div>
            <div class="price">${formatCurrency(this.vendor_price / 100)}</div>
          </li>                        
        </ul>
      </div>`
      let dom = $(html)
      dom.on('click', '.count-btn', function() {
        let type = $(this).data('btntype')
        switch (type) {
          case 'minus':
            if (self.quantity_num < 2) {
              return
            } 
            self.minus(dom)
            break;
          case 'plus':
            self.plus(dom)
            break;
        }
      })
      return dom
    }
    minus(dom) {
      this.quantity_num --
      let price = formatCurrency(this.quantity_num * this.good.sku_price / 100)
      dom.find('.quantity').html(this.quantity_num)
      dom.find('.price').html(`${price}`)
    }
    plus(dom) {
      this.quantity_num ++
      let price = formatCurrency(this.quantity_num * this.good.sku_price / 100)
      dom.find('.quantity').html(this.quantity_num)
      dom.find('.price').html(`${price}`)
    }
  }

  $('#addresslist').on('click', 'li', function() {    
    var type = $(this).data('item_type')
    if (type === 'normal') {
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
    } else {
      var index = layer.open({
        type: 1,
        title: '添加收货地址' ,
        area: '460px',
        shade: 0.8,
        id: 'addressEdit',
        move: false,
        end: addReset,
        content: $('.edit-dialog'),
        success: function(res) {
          $('#province_id').html(provinces_html)
          $('#city_id').html('')
          $('#country_id').html('')
          form.render('select', 'addressform')
          form.on('select(province_id)', function(data) {
            Area.handleProvinceSelect(data)
          })   
          form.on('select(city_id)', function(data) {
            Area.handleCitySelect(data)
          })           
          $(res).on('click', '.cancel', function() {            
            layer.close(index)
          })
        }        
      })
    }
  })

  $('.mall-orderlist-tab').on('click', 'li', function() {
    $(this)
      .addClass('current')
      .siblings()
      .removeClass('current')    
    orderparams.orderStatus = $(this).data('status')
    getOrderlist()
  })

  function getAddlist() {
    var index = layer.load(1)
    MALL.getAddress(function(res) {   
      layer.close(index)   
      if (!res[0]) {        
        var data = res[1].data
        var length = data.list.length > 4 ? 5 : (data.list.length + 1)
        if ($('#addresslist').data('mode') === 'select') {
          $('#addresslist')
            .css('width', `${240 * length }px` )
        }
        $('#addresslist').html('')
        data.list.map(v => {        
          let item = new AddressItem(v)
          $('#addresslist').append(item.init())        
        })
      }
      if (!res[0] && res[1].data.list.length > 4){
        return
      }  
      $('#addresslist').append(
        `<li class="mall-address-list-item addnew" data-item_type="add">
          <div>
            <img src="/@@/images/mall/address-add.svg">
          </div>
          添加新地址
        </li>`
      )     
    })
  }

  function getOrderlist() {
    var index = layer.load(1)
    MALL.getOrderlist(orderparams, function(res) {
      layer.close(index)
      if (!res[0]) {
        var data = res[1].data
        if (data.list.length === 0) {
          $('#orderlist').html('暂无订单信息')
          return
        }        
        $('#orderlist').html('')
        data.list.map(v => {
          let item = new OrderlistItem(v)
          $('#orderlist').append(item.init())
        })  
        laypage.render({
          elem: 'page',
          limit: 10,
          layout: ['count', 'prev', 'page', 'next'],
          curr: orderparams.page,
          theme: '#598CFF',
          count: data.total,
          jump: function(obj, first) {
            if(!first){
              orderparams.page = obj.curr
              getOrderlist()
            }            
          }
        })               
      }
    })
  }

  function addReset() {
    now_address_id = ''
    form.val('addressform', {
      address_detail: '',
      city_id: '',
      country_id: '',
      default_flag: true,
      province_id: '',
      receiver_mobile: '',
      receiver_name: ''
    })
  }
  function psdReset() {
    form.val('pwdform', {
      opwd: '',
      npwd: '',
      cpwd: ''
    })
  }

  // 结算按钮
  $('#gosettle').on('click', function() {    
    let address_id = $('.mall-address-list').find('.current').data('addid')
    if (!address_id) {
      layer.msg('请选择收货地址')
      return
    }
    let sku_quantity = $('#sku_quantity').text()
    let params = {
      address_id: Number(address_id),
      delivery_type: 1001,
      invoice_flag: false,
      invoice_id: 3,
      order_channel: '2',
      pay_type: 1,
      remark: '',
      sku_dto: {
        remark: '',
        sku_id: 37,
        sku_quantity: Number(sku_quantity)
      }    
    }
    MALL.generateOrder(params, function(res) {
      if (!res[0]) {
        if (res[1].code === 0) {
          layer.msg('订单创建成功,即将前往支付页面')
          MALL.generatePay(res[1].data.order_id, function(res) {
            if (!res[0]) {
              if (res[1].code === 0) {
                let payform = $(res[1].data)
                $(payform[0]).attr('target', '_blank')
                $('html body').append(payform)
                layer.open({
                  title: '提示',
                  closeBtn: 0,
                  content: '订单支付中',
                  btn: ['支付完成', '再看看'],
                  yes: function() {
                    location.href = '/mall/orderlist.html'       
                  },
                  btn2: function() {
                    location.href = '/mall/loadometer.html'
                  }                       
                })                
              } else {
                layer.msg(res[1].message)
              }
            }
          })
        } else {
          layer.msg(res[1].message)
        }
      } else {
        layer.msg(res.message)
      }
    })
  })
})
